//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        showButton: {
            default: true,
            required: false
        }
    },
    data: function data() {
        return {
            coa: {},
            activeTab: 0,
            accountData: {
                name: '',
                number: '',
                can_post_to: false
            },
            parentAccount: {
                id: 0,
                display: 'No Parent'
            },
            accountCategory: '',
            showAdd: false,
            loading: true,
            accountValidations: [{ model: 'accountData.name', rules: 'required' }, { model: 'accountData.number', rules: 'required' }, { model: 'accountCategory', rules: 'required' }]
        };
    },
    created: function created() {
        var _this = this;

        var $el = this;

        Event.$on('get-accounts', function (category) {
            Event.$emit('set-accounts', $el.coa.categories[category].accounts);
        });

        Event.$on('refresh-gl-coa-accounts', this.refreshGLCoaAccounts);

        Event.$on('show-chart-of-accounts', function () {
            return _this.open();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('get-accounts');
        Event.$off('refresh-gl-coa-accounts');
        Event.$off('show-chart-of-accounts');
    },

    methods: {
        refreshGLCoaAccounts: function refreshGLCoaAccounts() {
            var $el = this;
            axios.post('/prototype/accounting/general-ledger/chart-of-accounts').then(function (response) {
                $el.coa = response.data;
                $el.loading = false;
            });
        },
        open: function open() {
            Event.$emit('show-full-modal');
            Event.$emit('refresh-gl-coa-accounts');
        },
        update: function update() {
            var $el = this;
            this.validator.setRules(this.accountValidations).validate();
            if (this.validator.fails()) {
                return;
            }

            axios.post('/prototype/accounting/general-ledger/chart-of-accounts/account', { account: this.accountData, parent: this.parentAccount, category: this.accountCategory }).then(function () {
                $el.accountData = {
                    name: '',
                    number: '',
                    can_post_to: false
                };
                $el.showAdd = false;
                Event.$emit('refresh-gl-coa-accounts');
            });
        }
    },
    computed: {
        filteredAccounts: function filteredAccounts() {
            return this.coa.categories[this.activeTab].accounts.map(function (account) {
                return {
                    id: account.id, display: account.number + ' - ' + account.name
                };
            });
        },
        filteredCategories: function filteredCategories() {
            return this.coa.categories.map(function (category) {
                return {
                    id: category.id, display: category.number + ' - ' + category.name
                };
            });
        }
    },
    mounted: function mounted() {
        this.$initValidator();
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/settings/ChartOfAccounts.vue
// module id = v+Tp
// module chunks = 0 1